export const INTERACTION_TYPES = [
    "Payment Reported",
    "Promise to Pay",
    "Refused to Pay",
    "Non Contactable",
    "Dispute",
    "Connected",
    "Unserviceable",
    "Settlement Reported",
];